import { QueryFunctionContext, useMutation, useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import { Campaign } from "@/types/djangio"

export interface ElectionCountdownResponse {
    days_to_election: number | null
    hours_to_election: number | null
    minutes_to_election: number | null
    seconds_to_election: number | null
    election_datetime: string | null
    election_day_start_in: string | null
    elections: unknown[]
}

export interface FetchPlaceholdersFromMessageParams {
    content: string
    subject: string
    fixed_pre_content: string
    fixed_post_content: string
    person_id?: string
}

export const fetchPlaceholdersFromMessage = async (params: FetchPlaceholdersFromMessageParams) => {
    const response = await api.get({
        model: DjangIO.app.grassroots.campaign.models.GrassrootsCampaign,
        action: "replace_message_placeholder_with_legislator",
        params: params as unknown as Record<string, string>,
    })
    return response?.json?.()
}

export const fetchElectionCountdown = async (): Promise<ElectionCountdownResponse> => {
    const response = await api.get("/gotv/elections/")
    return response.json()
}

export const useFetchPlaceholdersFromMessage = (officialId?: string) => {
    const mutation = useMutation({
        mutationKey: ["fetchPlaceholdersFromMessage", officialId],
        mutationFn: (params: FetchPlaceholdersFromMessageParams) => fetchPlaceholdersFromMessage(params),
    })

    return mutation
}

const fetchCampaign = async ({ queryKey }: QueryFunctionContext<[string]>) => {
    const [campaignId] = queryKey
    return api
        .get({
            resourceUri: DjangIO.app.grassroots.campaign.models.GrassrootsCampaign.resourceUriFromId(campaignId),
            params: {
                decode_enums: "false",
                count: "false",
                dehydrate_extra: "",
            },
        })
        .then((resp) => resp.json()) as Promise<Campaign>
}

export const useCampaign = (campaignId: string) =>
    useQuery({
        queryKey: [campaignId],
        queryFn: fetchCampaign,
        enabled: Boolean(campaignId),
        staleTime: Infinity,
    })
